<template>
  <div v-if="true">

    <user-info :visit="visit" :loading="loadingVisit"/>

    <h2 class="title">Просмотр данных термограммы и добавление комментария</h2>
    <div v-loading="loadingDevices" class="box-card">



      <device-item
          :device="conclusion"
          :visitId="visitId"
          :conclusion="true"
          :conclusionComment="devices.conclusion"

          @openFile="openFile"
      ></device-item>


      <el-card class="box-card" v-loading="loadingDevices">
        <div class="devices" v-if="devices">

          <device-item
              v-for="device in devices.devices"
              :key="device.id"
              :device="device"
              :visitId="visitId"
              :comment="devices.comments"
              @openHeatMap="openHeatMap"
              @openFile="openFile"
          ></device-item>

        </div>
      </el-card>




    </div>


    <close-btns/>

  </div>
</template>

<script>

import {mapActions, mapGetters, mapMutations} from "vuex"
import Vue from "vue"
import VueMask from "v-mask"

import UserInfo from "@/components/visit/UserInfo.vue"
import DeviceItem from "@/components/visit/DeviceItem"
import CloseBtns from "@/components/heatMarker/CloseBtns"

Vue.use(VueMask);

export default {
  name: "heatMarker.item",
  components: {UserInfo, DeviceItem, CloseBtns},
  data: function () {
    return {
      visit: {
        user: {},
        worker: {}
      },
      conclusion: {
        title: "Комментарий во время визита",
      },

      card: null,

      loadForm: false,
      errorLoadCard: false,
      loadingVisit: true,
      loadingCard: true,
      loadingDevices: false,
      questionnaireTwo: [],
      pollQuestionnaireTwo: [],

      loadingQuestionnaire: true,

    };
  },
  computed: {
    ...mapGetters("visit", {visitStage: "data", devices: "getDevices"}),

    visitId() {
      return this.$route.params.id;
    },

  },

  created() {
    if (this.visitId) this.loadLogic();
    else this.$router.push({name: "visit.list"});

    this.setStageVisit(1);
  },
  filters: {
    bool(text) {
      return text ? "Да" : "Нет";
    },
    genderTitle(type) {
      let title = ''
      if (type == 'male') title = 'мужской';
      if (type == 'female') title = 'женский';
      return title
    },
    age(n) {
      let arr = ["год", "года", "лет"];
      return (
          n +
          " " +
          arr[
              n % 100 > 4 && n % 100 < 20
                  ? 2
                  : [2, 0, 1, 1, 1, 2][n % 10 < 5 ? n % 10 : 5]
              ]
      );
    },
  },
  methods: {
    ...mapMutations({}),
    ...mapActions({
      setStageVisit: "visit/SET_STAGE",
      setComment: "visit/SET_COMMENT",
      setVisit: "visit/SET_DATA",
      loadVisitData: "visit/LOAD_VISIT_DATA",
    }),

    loadLogic() {
      this.loadVisit();

      this.loadDevices();
    },
    loadDevices() {
      this.loadingDevices = false;
      this.loadVisitData({ visitId: this.visitId })

      // this.loadPolls();
    },
    openHeatMap(diagnosticData) {
      this.pageLoading(true)

      this.showModalHeatMap = true;
      this.diagnosticData = diagnosticData;

      this.pageLoading(false);
    },
    openFile(file) {

      // todo что это?
      this.showFile = file;
      this.isVisibleFileViewer = true;
    },
    loadVisit() {
      this.loadingVisit = true;
      this.$api.visit
          .get(this.visitId)
          .then((response) => {
            this.visit = response.data;
            this.loadCardOne(1);

            this.setComment(this.visit.comment);
            this.setVisit(this.visit);
          })
          .catch((response) => {
            this.$notify.error({
              title: "Ошибка загрузки списка 😕",
              message: response.response.data.message,
            });
          })
          .finally(() => {
            this.loadingVisit = false;
          });
    },
    loadCardOne() {
      // this.loadingCard = true


    },
    async goDevices() {
      await this.$router.push({
        name: "visit.device",
        params: {id: this.visit.id, visit: this.visit},
      });
    },
  },
};
</script>

<style scoped lang="scss">
.box-cards {
  @media screen and (min-width: 1000px) {
    display: flex;
    align-items: flex-start;
  }
}


.title {
  font-weight: 500;
  font-size: 13px;

  line-height: 1;
  color: #111;
  padding: 0;

  margin-top: 20px;
}


.error-load {
  margin: 0 auto;
  text-align: center;
}


.questions-card {
  .title {
    margin: 20px 0 10px 0;
    font-weight: 500;
    font-size: 12px;
    line-height: 13px;

    display: flex;
    align-items: center;
    letter-spacing: 0.005em;


    color: #111;
  }
}


.box-card {
  max-width: 1560px;
  background: #fff;
  border: 0;
  box-shadow: none;
  background: none;
}


.devices {
  margin: 0 auto;
  padding-top: 2px;

  &__item {
    background: #fff;
    border: #fff;
    color: #606266;
    transition: 0.3s;
    padding: 20px;
    max-width: 90%;
    margin-top: 10px;

    border-radius: 4px;
    overflow: hidden;

    &:hover {
      //box-shadow: 2px 2px 24px 2px rgba(0, 0, 0, 0.1);
    }
  }

  &__name {
    color: #444;
    font-weight: 500;
    font-size: 17px !important;
    line-height: 26px;
    display: inline;
  }

  &__link {
    display: inline;
    padding: 0 5px;

    font-weight: 500;
    font-size: 17px;
    color: #222;
    line-height: 120%;
  }

  &__btn {
    float: right;
    padding: 5px 6px;
  }
}

.device-info {
  &__value {
    color: #383838;
    font-size: 14px !important;
    margin: 10px 0 0 0;

    span {
      color: #3a8ee6;
    }
  }

  &__file {
    color: #383838;
    font-size: 14px !important;
    line-height: 1;
    margin: 10px 0 0 0;

    * {
      vertical-align: baseline !important;
    }

    .title {
      font-size: 14px;
      line-height: 1;
      color: #444;
      padding: 0 5px;
    }

    span {
      line-height: 1;
      font-size: 14px;
      color: #3a8ee6;
    }
  }
}

.box-card /deep/ .el-card__body {
  padding: 0 0 10px 0 !important;
}

.btn {
  margin-top: 0px;
}

.tabs {
  margin-top: 16px;

  /deep/ .el-tabs__item.is-active {
    color: #111;
  }

  /deep/ .el-tabs__active-bar {
    background-color: #111;
  }

  /deep/ .el-tabs__item {
    color: #8E8E93;
  }
}
</style>
